import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import ReactPlayer from "react-player";
import styled from "styled-components";
import Request from "superagent";

import Header from "../components/Header";
import Footer from "../components/Footer";
import Loader from "../components/Loader";

import WelcomeImg from "../images/welcome.png";
import CamaraImg from "../images/camara.png";
import Icon1 from "../images/icon1.png";
import Icon2 from "../images/icon2.png";
import Icon3 from "../images/icon3.png";
import IconFIle from "../images/iconfile.png";
import IconDownload from "../images/icondownload.png";

import {
  WhiteSpace,
  Row,
  RowCenter,
  Column,
} from "../components/GlobalStyles";

/* ============================
   TEXTOS (gestión interna)
============================ */

const languageText = {
  es: {
    welcome: "¡Bienvenido!",
    download1:
      "Para descargar sus imágenes, siga las instrucciones a continuación. También puede descargar todas las imágenes a la vez usando el botón 'DESCARGAR TODO' ubicado sobre las imágenes.",
    celortablet: "Celular o tablet",
    pcordlaptop: "PC o Laptop",
    selectphoto: "Seleccionar imagen",
    selecttheimage:
      "Seleccione la imagen para descargar y presione el ícono de descarga.",
    hovertheimage:
      "Coloca el cursor sobre la imagen para descargar y presiona el ícono de descarga.",
    clickonthephoto:
      "Haga clic en la foto para seleccionar, presione el botón DESCARGAR SELECCIONADAS para descargar las imágenes seleccionadas.",
    downloadAll: "DESCARGAR SELECCIONADAS",
    downloadEverything: "DESCARGAR TODO",
    galleryTitle: "Tus fotos de la experiencia",
    gallerySubtitle:
      "Selecciona tus momentos favoritos. Puedes descargar una por una o todas con el botón 'DESCARGAR TODO' ubicado sobre las imágenes.",
    photosFound: "fotos encontradas",
    selected: "seleccionadas",
    downloading: "DESCARGANDO",
  },
  en: {
    welcome: "WELCOME!",
    download1:
      "To download your pictures follow the instructions below. You can also download all images at once using the 'DOWNLOAD ALL' button located above the images.",
    celortablet: "Cell phone or tablet",
    pcordlaptop: "PC or Laptop",
    selectphoto: "Select photo",
    selecttheimage: "Select the image to download and press the download icon.",
    hovertheimage: "Hover the image to download and press the download icon.",
    clickonthephoto:
      "Click on the photo to select, press the DOWNLOAD SELECTED button to download selected images.",
    downloadAll: "DOWNLOAD SELECTED",
    downloadEverything: "DOWNLOAD ALL",
    galleryTitle: "Your experience photos",
    gallerySubtitle:
      "Pick your favorite moments. Download one by one or all with the 'DOWNLOAD ALL' button located above the images.",
    photosFound: "photos found",
    selected: "selected",
    downloading: "DOWNLOADING",
  },
};

/* ============================
   STYLES (styled-components)
   (copiado/igual a tu diseño)
============================ */

const HomeContent = styled.main`
  position: relative;
  width: 100vw;
  margin-left: calc(50% - 50vw);
  min-height: 100vh;
  padding-top: 120px;
  padding-bottom: 80px;
  overflow-x: hidden;
  background: radial-gradient(
    circle at top left,
    #dbe6ff 0,
    #f3f4fa 35%,
    #e9efff 70%,
    #f9fafb 100%
  );

  &::before {
    content: "";
    position: fixed;
    inset: 0;
    background-image: radial-gradient(
      circle at 1px 1px,
      rgba(24, 36, 70, 0.08) 1px,
      transparent 0
    );
    background-size: 22px 22px;
    opacity: 0.35;
    pointer-events: none;
    z-index: -1;
  }
`;

const PageInner = styled.div`
  width: 100%;
  margin: 0 auto;
  padding-inline: clamp(24px, 8vw, 140px);
  box-sizing: border-box;
`;

const Orb = styled.div`
  position: absolute;
  border-radius: 9999px;
  filter: blur(40px);
  opacity: 0.65;
  pointer-events: none;
  z-index: 0;
`;

const Banner = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  z-index: 1;
  gap: 32px;
`;

const HeroStrip = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 0.75rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #64748b;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const HeroChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(148, 163, 184, 0.7);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.25);
  font-size: 0.7rem;
  text-transform: none;
`;

const StatusDot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: #22c55e;
  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.35);
`;

const HeroGrid = styled.div`
  border-radius: 1.8rem;
  padding: 28px 28px 26px;
  background: radial-gradient(circle at top left, #020617 0, #020617 40%, #0b1120 100%);
  border: 1px solid rgba(15, 23, 42, 0.7);
  box-shadow: 0 34px 90px rgba(15, 23, 42, 0.98);
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(260px, 1fr);
  gap: 24px;
  align-items: center;

  @media (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

const HeroLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const SectionTag = styled.p`
  letter-spacing: 0.18em;
  text-transform: uppercase;
  font-size: 0.7rem;
  color: #9ca3af;
`;

const WelcomeTitle = styled.h1`
  font-size: clamp(2.4rem, 4vw, 3.8rem);
  font-weight: 900;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #c8e73a;
  text-shadow: 0 18px 40px rgba(0, 0, 0, 1);
`;

const WelcomeSub = styled.p`
  margin-top: 4px;
  color: #e5e7eb;
  max-width: 520px;
  font-size: 0.94rem;
  line-height: 1.6;
`;

const HeroTextRow = styled(RowCenter)`
  margin-top: 14px;
  align-items: center;
  justify-content: flex-start;

  p {
    color: #e5e7eb;
    max-width: 520px;
    font-size: 0.9rem;
  }

  @media (max-width: 900px) {
    justify-content: flex-start;
  }
`;

const ImgCamera = styled.img`
  width: 38px;
  margin-right: 10px;
`;

const HeroBadges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 18px;
  font-size: 0.76rem;
  color: #9ca3af;
`;

const HeroPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 11px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.9);
  border: 1px solid rgba(148, 163, 184, 0.7);
`;

const PillDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #8bc34a;
`;

const HeroRight = styled.div`
  border-radius: 1.4rem;
  padding: 20px 18px 16px;
  background: radial-gradient(circle at top left, #020617, #020617 45%, #020617);
  border: 1px solid rgba(148, 163, 184, 0.8);
  color: #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const MiniTitle = styled.p`
  font-size: 0.7rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #9ca3af;
`;

const WelcomePreviewFrame = styled.div`
  border-radius: 1.1rem;
  padding: 10px 16px;
  background: radial-gradient(circle at top left, #e5f3ff, #ffffff);
  border: 1px solid rgba(148, 163, 184, 0.7);
  display: flex;
  justify-content: center;
`;

const WelcomePreview = styled.img`
  width: 100%;
  max-width: 260px;
  object-fit: contain;
`;

const HeroStatsRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  font-size: 0.8rem;
`;

const StatChip = styled.div`
  flex: 1;
  padding: 7px 10px;
  border-radius: 0.9rem;
  background: rgba(15, 23, 42, 0.98);
  border: 1px solid rgba(148, 163, 184, 0.7);
  display: flex;
  flex-direction: column;
  gap: 2px;

  span:first-child {
    font-size: 0.7rem;
    color: #9ca3af;
  }

  span:last-child {
    font-weight: 600;
    color: #e5e7eb;
  }
`;

const StepsContainer = styled.div`
  width: 100%;
  margin-top: 32px;
`;

const StepsStripTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 14px;
  font-size: 0.9rem;
  color: #64748b;

  span:first-child {
    font-weight: 600;
    color: #0f172a;
  }

  span:last-child {
    font-size: 0.78rem;
  }

  @media (max-width: 640px) {
    flex-direction: column;
  }
`;

const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-gap: 18px;
  width: 100%;
  margin: 0 auto;

  @media (max-width: 900px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

const StepCard = styled.div`
  position: relative;
  display: flex;
  align-items: stretch;
  gap: 12px;
  padding: 16px 18px;
  border-radius: 1.4rem;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.98),
    rgba(235, 246, 255, 0.98)
  );
  border: 1px solid rgba(148, 163, 184, 0.6);
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.16);
  overflow: hidden;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;

  &:before {
    content: "";
    position: absolute;
    inset: 0;
    background: radial-gradient(
      circle at top right,
      rgba(139, 195, 74, 0.16),
      transparent 55%
    );
    mix-blend-mode: soft-light;
    pointer-events: none;
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 22px 50px rgba(15, 23, 42, 0.24);
    border-color: rgba(139, 195, 74, 0.9);
  }
`;

const StepBadge = styled.div`
  min-width: 32px;
  height: 32px;
  border-radius: 999px;
  background: linear-gradient(135deg, #8bc34a, #10b981);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #041528;
  font-size: 0.88rem;
  font-weight: 700;
  box-shadow: 0 10px 22px rgba(16, 185, 129, 0.6);
  z-index: 1;
`;

const StepContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  z-index: 1;

  h5 {
    font-size: 0.98rem;
    color: #0f172a;
    font-weight: 600;
  }

  p {
    font-size: 0.84rem;
    margin-top: 2px;
    color: #64748b;
  }
`;

const StepIconBubble = styled.div`
  width: 46px;
  height: 46px;
  border-radius: 999px;
  background: radial-gradient(circle at top, #e5f6ff, #ffffff);
  border: 1px solid rgba(148, 163, 184, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;

  img {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }
`;

const FotosWrapper = styled.div`
  width: 100%;
  margin-top: 36px;
  padding: 24px 24px 30px;
  border-radius: 1.8rem;
  background: radial-gradient(
      circle at top left,
      rgba(232, 244, 255, 0.9),
      rgba(255, 255, 255, 0.98)
    ),
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.98),
      rgba(232, 240, 255, 0.98)
    );
  border-top: 3px solid #8bc34a;
  border-inline: 1px solid rgba(148, 163, 184, 0.5);
  border-bottom: 1px solid rgba(148, 163, 184, 0.5);
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.22);

  max-height: none;
  overflow: visible;

  @media (max-width: 768px) {
    padding: 18px 14px 24px;
    border-radius: 1.6rem;
  }
`;

const GalleryHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 22px;
  padding-bottom: 10px;
  border-bottom: 1px dashed rgba(148, 163, 184, 0.7);
`;

const GalleryTitleBlock = styled.div`
  h3 {
    font-size: 1.35rem;
    font-weight: 700;
    color: #0f172a;
  }

  p {
    margin-top: 5px;
    font-size: 0.86rem;
    color: #6b7280;
    max-width: 520px;
  }
`;

const GalleryBadges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 0.75rem;
`;

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  background: ${(p) => p.bg || "rgba(15, 23, 42, 0.95)"};
  color: ${(p) => p.color || "#e5e7eb"};
  border: 1px solid ${(p) => p.border || "rgba(15, 23, 42, 0.8)"};

  strong {
    font-weight: 700;
  }
`;

const FotosContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-gap: 22px;
  width: 100%;
  max-height: none;
  overflow: visible;

  @media (max-width: 1280px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

const FotoCard = styled(Column)`
  position: relative;
  cursor: pointer;
  border-radius: 1.15rem;
  overflow: hidden;
  background-color: #020617;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.45);
  transform: translateY(0);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  img {
    width: 100%;
    height: auto;
    display: block;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 18px 44px rgba(15, 23, 42, 0.7);

    .overlay {
      opacity: 1;
    }
  }

  .overlay {
    position: absolute;
    inset: 0;
    opacity: 0;
    background: linear-gradient(
      135deg,
      rgba(139, 195, 74, 0.94),
      rgba(16, 185, 129, 0.96)
    );
    justify-content: center;
    align-items: center;
    display: flex;
    transition: opacity 0.18s ease-in-out;

    .icon {
      width: 18%;
      max-width: 60px;
    }
  }
`;

const VideoTag = styled.span`
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 4px 9px;
  border-radius: 999px;
  font-size: 0.65rem;
  background: rgba(15, 23, 42, 0.94);
  color: #e5e7eb;
  border: 1px solid rgba(148, 163, 184, 0.8);
`;

const FotoSelect = styled(Row)`
  position: relative;
  background: linear-gradient(
    to right,
    rgba(4, 21, 40, 1),
    rgba(15, 23, 42, 0.98)
  );
  height: 38px;
  padding: 0 12px;
`;

const CheckboxContainer = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  cursor: pointer;
  user-select: none;
  transition: all 0.25s ease-in-out;

  p {
    font-size: 0.78rem;
    color: ${(props) =>
      props.theme.photoSelectorColor ? props.theme.photoSelectorColor : "#e5e7eb"};
    padding: 1px;
    max-width: 220px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkmark {
    height: 20px;
    width: 20px;
    background-color: #e5e7eb;
    position: relative;
    border-radius: 6px;
    transition: background-color 0.2s ease, box-shadow 0.2s ease;
  }

  input ~ .checkmark {
    background-color: #cbd5f5;
  }

  input:checked ~ .checkmark {
    background: linear-gradient(135deg, #22c55e, #16a34a);
    box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.4);
  }

  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  input:checked ~ .checkmark:after {
    display: block;
  }

  .checkmark:after {
    left: 6px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }
`;

const ButtonsRow = styled(Row)`
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 30px 0 10px;
  position: sticky;
  bottom: 8px;
  z-index: 99;
`;

const DownloadBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: min(680px, 100%);
  padding: 10px 16px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.98);
  border: 1px solid rgba(148, 163, 184, 0.7);
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.8);
  color: #e5e7eb;

  @media (max-width: 640px) {
    flex-direction: column;
    border-radius: 18px;
    align-items: stretch;
  }
`;

const DownloadInfo = styled.div`
  font-size: 0.8rem;
  span {
    font-weight: 600;
    color: #a5b4fc;
  }
`;

const DownloadButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 340px;
  width: 100%;
  background: linear-gradient(to right, #8bc34a, #10b981);
  color: #041528;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  padding: 10px 22px;
  text-align: center;
  border-radius: 999px;
  transition: all 0.25s ease-in-out;
  box-shadow: 0 14px 36px rgba(16, 185, 129, 0.6);
  border: 0;
  letter-spacing: 0.06em;
  text-transform: uppercase;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 20px 48px rgba(16, 185, 129, 0.8);
    filter: brightness(1.05);
  }

  img {
    margin-left: 12px;
    width: 28px;
  }

  &:disabled {
    opacity: 0.7;
    cursor: default;
    transform: none;
    box-shadow: none;
  }
`;

const GalleryDownloadButton = styled(DownloadButton)`
  max-width: 220px;
  padding: 8px 14px;
  font-size: 0.82rem;
  box-shadow: 0 10px 28px rgba(16, 185, 129, 0.5);
  align-self: center;

  img {
    width: 18px;
    margin-left: 8px;
  }

  @media (max-width: 640px) {
    max-width: 100%;
  }
`;

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SpinnerSvg = styled.svg`
  animation: rotate 1s linear infinite;
  width: 20px;
  height: 20px;

  .path {
    stroke: #ffffff;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;

/* ============================
   COMPONENTE PRINCIPAL
============================ */

function Home({ logo, welcomeImg }) {
  const [fotos, setFotos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingAll, setLoadingAll] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState([]);
  const [selected, setSelected] = useState([]);
  const [language, setLanguage] = useState("en");
  const [textos, setTextos] = useState(languageText.en);

  // progreso de descarga masiva
  const [progressCurrent, setProgressCurrent] = useState(0);
  const [progressTotal, setProgressTotal] = useState(0);

  // número de descargas simultáneas (ajustable)
  const CONCURRENCY = 4;

  const host = "https://gimav-images.herokuapp.com";
  const params = useParams();
  const videoUrlsRef = useRef([]);

  useEffect(() => {
    getFotos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setTextos(language === "es" ? languageText.es : languageText.en);
  }, [language]);

  useEffect(() => {
    return () => {
      if (videoUrlsRef.current && videoUrlsRef.current.length > 0) {
        videoUrlsRef.current.forEach((u) => {
          try {
            URL.revokeObjectURL(u);
          } catch (e) {
            // ignore
          }
        });
        videoUrlsRef.current = [];
      }
    };
  }, []);

  const totalSelected = selected.length;
  const totalFotos = fotos.length;
  const hasVideo = fotos.some((f) => f.key.split(".").pop() === "mp4");

  async function getFotos() {
    setLoading(true);
    try {
      const res = await Request.get(`${host}/imagenes/get/bucket?url=${params.qr}/`).set("sitio", `${params.sitio}`);
      if (res.body && Array.isArray(res.body)) {
        const newFotos = res.body.map((f) => ({
          url: `${host}/imagenes/get/imagen/${params.sitio}/${f.Key}`,
          key: f.Key,
          name: f.name,
        }));

        const videosObj = newFotos.filter((o) => o.key.split(".").pop() === "mp4");

        if (videosObj && videosObj.length > 0) {
          await generateUrlVideo(videosObj, newFotos);
        } else {
          setFotos(newFotos);
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  const generateUrlVideo = async (data, resBody) => {
    const auxFETCH = [];

    for (let i = 0; i < data.length; i++) {
      try {
        const response = await fetch(`${host}/imagenes/download/${params.sitio}/${data[i].key}`, {
          method: "GET",
          headers: {
            sitio: `${params.sitio}`,
          },
        });
        const myBlob = await response.blob();
        const objectURL = URL.createObjectURL(myBlob);
        videoUrlsRef.current.push(objectURL);
        auxFETCH.push({ ...data[i], url: objectURL });
      } catch (err) {
        console.log(err);
      }
    }

    const newArr = resBody.map((obj) => {
      const fetchResponse = auxFETCH.filter((x) => x.key === obj.key);
      if (fetchResponse.length > 0) {
        return {
          ...obj,
          url: fetchResponse[0].url,
        };
      }
      return obj;
    });

    setFotos(newArr);
  };

  const download = async (fotoKey) => {
    setLoadingDownload((prev) => [...prev, fotoKey]);

    try {
      const response = await fetch(`${host}/imagenes/download/${params.sitio}/${fotoKey}`, {
        method: "GET",
        headers: {
          sitio: `${params.sitio}`,
        },
      });
      const buffer = await response.arrayBuffer();
      const blobUrl = window.URL.createObjectURL(new Blob([buffer]));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fotoKey);
      document.body.appendChild(link);
      link.click();
      link.remove();
      try {
        window.URL.revokeObjectURL(blobUrl);
      } catch (e) {
        // ignore
      }
    } catch (err) {
      console.log(err);
      // opcional: podrías acumular errores y mostrarlos al final
    } finally {
      setLoadingDownload((prev) => prev.filter((i) => i !== fotoKey));
    }
  };

  // descarga paralela limitada por CONCURRENCY, actualiza progreso
  const downloadAll = async () => {
    const targets = selected.length > 0 ? selected : fotos.map((f) => f.key);
    if (!targets || targets.length === 0) return;

    setProgressTotal(targets.length);
    setProgressCurrent(0);
    setLoadingAll(true);

    // índice compartido para tomar la próxima tarea
    let index = 0;
    let completed = 0;

    const worker = async () => {
      while (true) {
        let current;
        // tomar la siguiente tarea (índice único)
        if (index < targets.length) {
          current = targets[index];
          index += 1;
        } else {
          break; // no hay más
        }

        // ejecutar descarga
        try {
          // await descarga individual (se ocupa loadingDownload internamente)
          // eslint-disable-next-line no-await-in-loop
          await download(current);
        } catch (err) {
          console.error("Error descargando", current, err);
        } finally {
          completed += 1;
          setProgressCurrent(completed);
        }
      }
    };

    // crear N workers
    const workers = [];
    const concurrency = Math.min(CONCURRENCY, targets.length);
    for (let i = 0; i < concurrency; i++) {
      workers.push(worker());
    }

    try {
      await Promise.all(workers);
    } catch (err) {
      console.error("Error en el pool de descargas:", err);
    } finally {
      setLoadingAll(false);
      // reset opcional del progreso después de un breve delay
      setTimeout(() => {
        setProgressCurrent(0);
        setProgressTotal(0);
      }, 800);
    }
  };

  const selectFoto = (fotoKey) => {
    setSelected((prevSelected) => {
      if (prevSelected.includes(fotoKey)) {
        return prevSelected.filter((f) => f !== fotoKey);
      }
      return [...prevSelected, fotoKey];
    });
  };

  return (
    <>
      <Header setLanguage={setLanguage} language={language} logo={logo} />

      <HomeContent>
        <Orb
          style={{
            top: "-80px",
            left: "-60px",
            width: "260px",
            height: "260px",
            background: "rgba(139, 195, 74, 0.5)",
          }}
        />
        <Orb
          style={{
            bottom: "-120px",
            right: "-40px",
            width: "320px",
            height: "320px",
            background: "rgba(56, 189, 248, 0.45)",
          }}
        />

        <PageInner>
          <Banner>
            <HeroStrip>
              <span>
                GIMAV Picture • {language === "es" ? "Portal de descarga" : "Download portal"}
              </span>
              <HeroChip>
                <StatusDot />
                {language === "es" ? "Sesión activa" : "Session active"}
              </HeroChip>
            </HeroStrip>

            <HeroGrid>
              <HeroLeft>
                <SectionTag>{language === "es" ? "Descarga tus fotos" : "Download your photos"}</SectionTag>
                <WelcomeTitle>{textos.welcome}</WelcomeTitle>
                <WelcomeSub>{textos.download1}</WelcomeSub>

                <HeroTextRow>
                  <ImgCamera src={CamaraImg} alt="camera" />
                  <p>{textos.clickonthephoto}</p>
                </HeroTextRow>

                <HeroBadges>
                  <HeroPill>
                    <PillDot />
                    <span>GIMAV Picture</span>
                  </HeroPill>
                  <HeroPill>
                    <PillDot />
                    <span>{language === "es" ? "Descarga digital" : "Digital download"}</span>
                  </HeroPill>
                  {hasVideo && (
                    <HeroPill>
                      <PillDot />
                      <span>{language === "es" ? "Incluye video" : "Includes video"}</span>
                    </HeroPill>
                  )}
                </HeroBadges>
              </HeroLeft>

              <HeroRight>
                <MiniTitle>{language === "es" ? "Resumen" : "Summary"}</MiniTitle>

                <WelcomePreviewFrame>
                  <WelcomePreview src={welcomeImg || WelcomeImg} alt="Preview" />
                </WelcomePreviewFrame>
                <HeroStatsRow>
                  <StatChip>
                    <span>{language === "es" ? "Fotos" : "Photos"}</span>
                    <span>{totalFotos}</span>
                  </StatChip>
                  <StatChip>
                    <span>{language === "es" ? "Seleccionadas" : "Selected"}</span>
                    <span>{totalSelected}</span>
                  </StatChip>
                </HeroStatsRow>
              </HeroRight>
            </HeroGrid>

            <StepsContainer>
              <StepsStripTitle>
                <span>{language === "es" ? "Cómo descargar tus recuerdos" : "How to download your memories"}</span>
                <span>
                  {language === "es"
                    ? "Compatible con celular, tablet, PC y laptop."
                    : "Compatible with phone, tablet, PC and laptop."}
                </span>
              </StepsStripTitle>

              <CardContainer>
                <StepCard>
                  <StepBadge>1</StepBadge>
                  <StepContent>
                    <h5>{textos.celortablet}</h5>
                    <p>{textos.selecttheimage}</p>
                  </StepContent>
                  <StepIconBubble>
                    <img src={Icon1} alt="Icon 1" />
                  </StepIconBubble>
                </StepCard>

                <StepCard>
                  <StepBadge>2</StepBadge>
                  <StepContent>
                    <h5>{textos.pcordlaptop}</h5>
                    <p>{textos.hovertheimage}</p>
                  </StepContent>
                  <StepIconBubble>
                    <img src={Icon2} alt="Icon 2" />
                  </StepIconBubble>
                </StepCard>

                <StepCard>
                  <StepBadge>3</StepBadge>
                  <StepContent>
                    <h5>{textos.selectphoto}</h5>
                    <p>{textos.clickonthephoto}</p>
                  </StepContent>
                  <StepIconBubble>
                    <img src={Icon3} alt="Icon 3" />
                  </StepIconBubble>
                </StepCard>
              </CardContainer>
            </StepsContainer>

            <WhiteSpace height="24" />

            {loading ? (
              <Loader />
            ) : (
              <FotosWrapper>
                <GalleryHeader>
                  <GalleryTitleBlock>
                    <h3>{textos.galleryTitle}</h3>
                    <p>{textos.gallerySubtitle}</p>
                  </GalleryTitleBlock>

                  <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                    <GalleryDownloadButton
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        downloadAll();
                      }}
                      disabled={loadingAll || fotos.length === 0}
                      aria-label={textos.downloadEverything}
                    >
                      {loadingAll ? (
                        <>
                          <SpinnerWrapper style={{ marginRight: 8 }}>
                            <SpinnerSvg viewBox="0 0 50 50">
                              <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" />
                            </SpinnerSvg>
                          </SpinnerWrapper>
                          {language === "es"
                            ? `${textos.downloading} ${progressCurrent}/${progressTotal}`
                            : `${textos.downloading} ${progressCurrent}/${progressTotal}`}
                        </>
                      ) : (
                        <>
                          {textos.downloadEverything}
                          <img src={IconFIle} alt="" aria-hidden="true" />
                        </>
                      )}
                    </GalleryDownloadButton>

                    <GalleryBadges>
                      <Badge>
                        <strong>{totalFotos}</strong> {textos.photosFound}
                      </Badge>
                      <Badge bg="rgba(139,195,74,0.14)" color="#166534" border="rgba(132,204,22,0.7)">
                        <strong>{totalSelected}</strong> {textos.selected}
                      </Badge>
                    </GalleryBadges>
                  </div>
                </GalleryHeader>

                <FotosContainer>
                  {fotos.map((foto) => {
                    const isVideo = foto.key.split(".").pop() === "mp4";
                    const isSelected = selected.includes(foto.key);

                    return (
                      <FotoCard key={foto.key} onClick={() => selectFoto(foto.key)}>
                        {isVideo && <VideoTag>⏺ {language === "es" ? "Video" : "Video"}</VideoTag>}

                        {isVideo ? (
                          <ReactPlayer url={foto.url} muted playing={false} controls width="100%" height="100%" />
                        ) : (
                          <img src={foto.url} alt={foto.name || "preview"} loading="lazy" />
                        )}

                        <div className="overlay">
                          {loadingDownload.includes(foto.key) ? (
                            <Loader />
                          ) : (
                            <img
                              src={IconDownload}
                              className="icon"
                              alt="Descargar"
                              onClick={(e) => {
                                e.stopPropagation();
                                download(foto.key);
                              }}
                            />
                          )}
                        </div>

                        <FotoSelect onClick={(e) => e.stopPropagation()}>
                          <CheckboxContainer>
                            <p>{foto.name}</p>
                            <input
                              type="checkbox"
                              checked={isSelected}
                              onChange={(e) => {
                                e.stopPropagation();
                                selectFoto(foto.key);
                              }}
                              aria-checked={isSelected}
                            />
                            <span className="checkmark" />
                          </CheckboxContainer>
                        </FotoSelect>
                      </FotoCard>
                    );
                  })}
                </FotosContainer>
              </FotosWrapper>
            )}

            {totalSelected > 0 && (
              <ButtonsRow>
                <DownloadBar>
                  <DownloadInfo>
                    {language === "es" ? "Listas para descargar: " : "Ready to download: "}
                    <span>{totalSelected}</span> {language === "es" ? "fotos" : "photos"}
                  </DownloadInfo>

                  {loadingAll ? (
                    <DownloadButton type="button" disabled>
                      <SpinnerWrapper>
                        <SpinnerSvg viewBox="0 0 50 50">
                          <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" />
                        </SpinnerSvg>
                      </SpinnerWrapper>
                    </DownloadButton>
                  ) : (
                    <DownloadButton type="button" onClick={downloadAll}>
                      {textos.downloadAll}
                      <img src={IconFIle} alt="Archivo" />
                    </DownloadButton>
                  )}
                </DownloadBar>
              </ButtonsRow>
            )}
          </Banner>
        </PageInner>
      </HomeContent>

      <Footer />
    </>
  );
}

export default Home;
